import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../mock";

// Visible on desktop only; mobile uses MobileBottomBar instead
const FloatingWhatsApp = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      className="hidden lg:inline-flex fixed bottom-5 right-5 z-50 items-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-xl shadow-emerald-500/30 px-4 py-3 transition-colors"
      aria-label="Chat on WhatsApp"
    >
      <span className="relative inline-flex">
        <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-amber-300 animate-pulse" />
        <MessageCircle className="h-5 w-5" />
      </span>
      <span className="text-[13.5px] font-medium">Chat on WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsApp;
